import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Left } from "../scheduling-linear-new/components/left/left";
import { SearchBar } from "../scheduling-linear-new/components/left/child-component/SearchBar";
import { useEffect, useRef, useState } from "react";
import {
    Schedules_list,
    Schedules_Datalist,
    Schedules_Datalist_Ist,
    saveLinerPrograms,
    adValidate,
    programValidate,
    Schedule_update_weekly
} from "../../../api/api";
import {
    fetchSchedule,
    confirmSaveAndUpdate
} from "../scheduling-linear-new/utils/fetchAndUpdateScheduleAPI";
import { 
    searchProgram, 
    millisecondsToHuman,
    verifyMilliSeconds,
    calculateMinutes,
    millisecondsSinceMidnightUTC,
    formatTime,
    generateTimeSlots,
    splitScheduleItems,
    selectedFiller,
} from "../scheduling-linear-new/utils/utils";
import { 
    totalScheduleTimeFun,
    getAssetInfo
 } from "../scheduling-loop/utils/utils";
import { ChannelListing } from "../scheduling-linear-new/components/left/child-component/ChannelListing";
import { AdsButton } from "../scheduling-linear-new/components/left/child-component/AdsButton";
import { Right } from "../scheduling-linear-new/components/right/Right";
import { DateNavigator } from "../scheduling-linear-new/components/right/child-component/DateNavigator";
import { toast, ToastContainer } from "react-toastify";
import { ButtonsToolBar } from "./components/ButtonsToolBar";
import { MiddleContent } from "../scheduling-loop/components/MiddleContent";
import { RightSideContent } from "../scheduling-loop/components/RightSideContent";
import { ZoomControls } from "../scheduling-loop/components/ZoomControls";
import { ScheduleDetails } from "../scheduling-loop/components/ScheduleDetails";
import { TableBody } from "../scheduling-linear-new/components/right/child-component/child-component/TableBody";
import { TimeSlots } from "../scheduling-loop/components/TimeSlots";
import _ from "lodash";
import { PanelLine } from "../scheduling-linear-new/components/right/child-component/child-component/PanelLine";
import { ExpandScheduleHead } from "./components/ExpandScheduleHead";
import { 
    handleDragStart,
    handleDragOver,
    handleDragOver2,
    channelDragStart, 
} from "../scheduling-linear-new/utils/handleDrag";
import { handleDrop } from "../scheduling-linear-new/utils/handleDrop";
import { DraggableItem } from "../scheduling-linear-new/components/right/child-component/child-component/DraggableItem";
import { DraggableEvent } from "../scheduling-linear-new/components/right/child-component/child-component/DraggableEvent";
import { AdMarker } from "../scheduling-linear-new/components/right/child-component/child-component/AdMarker";
import { HoverLine } from "../scheduling-linear-new/components/right/child-component/child-component/HoverLine";
import { handleProgramDelete } from "../scheduling-linear-new/utils/handleDelete";
import AssetInfoCard from "../scheduling-loop/components/AssetInfoCard";
import AdBreaksTable from "../scheduling-loop/components/AdBreaksTable";
import { NavigationButtons } from "../scheduling-loop/components/NavigationButtons";
import deleteIcon from '../../../assets/images/delete_forever.png';
import { setAdsTime } from "../scheduling-linear-new/utils/utils";
import { deleteEvent } from "../scheduling-linear-new/utils/handleDelete";
import { addAdsOnClick } from "../scheduling-linear-new/utils/utils";
import { updateLinearSchedule } from "./utils/updateLinearSchedule";
import ErrorPopup from "../../../component/popup/ErrorPopup";
import useUndo from "use-undo";

function LinearExpandView() {

    const [loaderStatus, setLoaderStatus] = useState(false);
    const [originalProgramList, setOriginalProgramList] = useState([]);
    const [promoList, setPromoList] = useState();
    const [fillerList, setFillerist] = useState();
    // const [gridList, setGridList] = useState();
    const [
        gridListState,
        {
            set: setGridList,
            reset: resetGridList,
            undo: undoGridList,
            redo: redoGridList,
            canUndo,
            canRedo,
        },
    ] = useUndo([]);
    const { present: gridList } = gridListState;
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const locationState = useLocation();
    const [programList, setProgramList] = useState();
    const [searchedText, setSearchedText] = useState("");
    const [saveBtnValue, setSaveBtnValue] = useState("Save & Publish");
    const [zoomInOut, setZoomInOut] = useState(1);
    const {
        appThemeReducer: { appTheme },
    } = useSelector((state) => state);
    const draggedItem = useRef();
    const [totalDuration, setTotalDuration] = useState({
        duration: "00:00:00",
        totalNum: 0,
    });
    const [totalVideoDuration, setTotalVideoDuration] = useState({
        duration: "00:00:00",
        totalNum: 0,
    });
    const [totalAdDuration, setTotalAdDuration] = useState({
        duration: "00:00:00",
        totalNum: 0,
    });
    const [totalPromosDuration, setTotalPromosDuration] = useState({
        duration: "00:00:00",
        totalNum: 0,
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [errorbox, setErrorbox] = useState(false);
    const [eventTrim, seteventTrim] = useState(null);
    const navigate = useNavigate();
    const [timeSlots, setTimeSlots] = useState([]);
    const [timeSlotss, setTimeSlotss] = useState([]);
    const [newGridData, setNewGridData] = useState([]);
    const [panelLinePosition, setPanelLinePosition] = useState(null);
    const [panelHoverDate, setPanelHoverDate] = useState(null);
    const [draggableType, setDraggableType] = useState(null);
    const [panelHoverTime, setPanelHoverTime] = useState(null);
    const [singleTimeSlots, setSingleTimeSlots] = useState([]);
    const [hoveredId, setHoveredId] = useState(null); 
    const [linePosition, setLinePosition] = useState(null);
    const [hoverTime, setHoverTime] = useState(null);
    const [assetInfo, setAssetInfo] = useState(null);
    const [seqId, setSeqId] = useState(0);
    const [showPopup, setShowPopup] = useState(false);
    const [categoryTab, setCategoryTab] = useState("Ads");

    const fetchLinearData = (startDateUTC, endDateUTC, setDate) => {
        fetchSchedule(
            setLoaderStatus,
            locationState,
            Schedules_list,
            setProgramList,
            setOriginalProgramList,
            setFillerist,
            setPromoList,
            Schedules_Datalist,
            Schedules_Datalist_Ist,
            setGridList,
            startDateUTC,
            endDateUTC,
            setDate
        );
        setStartDate(startDateUTC);
        setEndDate(endDateUTC);
    }

    const today = () => {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        const epoch = date.getTime();
        navigate(locationState.pathname, {
            state: {
              ...locationState.state,
              panelDate: epoch,
            },
        });
    }

    const fetchDataByDate = () => {

        const date = new Date(locationState?.state?.panelDate);
        const setDate = 1;

        // Local timezone ke hisaab se ek din pehle aur baad ka date
        const start = new Date(date);
        start.setDate(date.getDate() - 1);

        const end = new Date(date);
        end.setDate(date.getDate() + setDate);

        // Format: YYYY-MM-DD
        const formatDate = (d) => {
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };
        
        const startDateFormatted = formatDate(start);
        const endDateFormatted = formatDate(end);
        
        fetchLinearData(startDateFormatted, endDateFormatted, setDate);
    }

    const totalScheduleTimeFunc = () => {
        const todayData = newGridData?.find(item => item.date === locationState?.state?.panelDate);
        totalScheduleTimeFun(
            todayData?.scheduleItems,
            singleTimeSlots,
            setTimeSlots,
            setTotalDuration,
            setTotalVideoDuration,
            setTotalAdDuration,
            setTotalPromosDuration
        )
    }

    useEffect(() => {
        fetchDataByDate();
    }, [locationState])

    useEffect( () => {
        totalScheduleTimeFunc();
    },[gridList])

    useEffect(() => {
        const slots = generateTimeSlots();
        setTimeSlotss(slots);
    }, []);

    useEffect(() => {
        splitScheduleItems(
            gridList,   
            _, 
            setNewGridData,
        );
        const hasEditEnabled = gridList?.some(item => item.isEdit);
        localStorage.setItem("isLinearEdit", JSON.stringify(hasEditEnabled));
    },[gridList])

    useEffect(() => {
        toGetAssetInfo(seqId);
        // if (newGridData?.length > 0 && seqId) {
        // }
    }, [newGridData, seqId]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.key === 'z') {
            e.preventDefault();
            if (canUndo) undoGridList();
            }
        
            if ((e.ctrlKey && e.key === 'y') || (e.ctrlKey && e.shiftKey && e.key === 'z')) {
            e.preventDefault();
            if (canRedo) redoGridList();
            }
        };
        
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [canUndo, canRedo, undoGridList, redoGridList]);

    const searchPrograms = (text) => {
        searchProgram(
            text,
            originalProgramList,
            setProgramList,
            setSearchedText,
        )
    }

    const handelProgramDoubleClick = () => {

    }

    const prevWeekFunc = (e) => {
        if (localStorage.getItem("isLinearEdit") === "true") {
            e.preventDefault(); // Prevent redirection
            setErrorMessage("Are you sure you want to leave this page without saving your changes?");
            setErrorbox(true);
            seteventTrim(() => async() => {
                localStorage.setItem("isLinearEdit", JSON.stringify(false));
                const previousDate = locationState?.state?.panelDate - 24 * 60 * 60 * 1000
                navigate(locationState.pathname, {
                    state: {
                    ...locationState.state,
                    panelDate: previousDate,
                    },
                });
            })
        } else {
            const previousDate = locationState?.state?.panelDate - 24 * 60 * 60 * 1000
            navigate(locationState.pathname, {
                state: {
                ...locationState.state,
                panelDate: previousDate,
                },
            });
        }
    }

    const nextWeekFunc = (e) => {
        if (localStorage.getItem("isLinearEdit") === "true") {
            e.preventDefault(); // Prevent redirection
            setErrorMessage("Are you sure you want to leave this page without saving your changes?");
            setErrorbox(true);
            seteventTrim(() => async() => {
                localStorage.setItem("isLinearEdit", JSON.stringify(false));
                const nextDate = locationState?.state?.panelDate + 24 * 60 * 60 * 1000
                navigate(locationState.pathname, {
                    state: {
                    ...locationState.state,
                    panelDate: nextDate,
                    },
                });
            })
        } else {
            const nextDate = locationState?.state?.panelDate + 24 * 60 * 60 * 1000
            navigate(locationState.pathname, {
                state: {
                ...locationState.state,
                panelDate: nextDate,
                },
            });
        }
    }

    const trim_programs_space = ((date) => {

    })

    const backToLinear = (e) => {
        const redirectPage =  "/scheduling-linear";
        const data = locationState?.state;
        
        if (localStorage.getItem("isLinearEdit") === "true") {
            e.preventDefault(); // Prevent redirection
            setErrorMessage("Are you sure you want to leave this page without saving your changes?");
            setErrorbox(true);
            seteventTrim(() => async() => {
                localStorage.setItem("isLinearEdit", JSON.stringify(false));
                navigate(redirectPage, {
                    state: {
                        channelId: data?.channelId,
                        channelName: data?.channelName,
                        type: data?.type,
                        defaultFiller: data?.defaultFiller,
                        permission: data?.permission,
                        channelAssembly: data?.channelAssembly,
                    }
                });
            })
        } else {
            navigate(redirectPage, {
                state: {
                    channelId: data?.channelId,
                    channelName: data?.channelName,
                    type: data?.type,
                    defaultFiller: data?.defaultFiller,
                    permission: data?.permission,
                    channelAssembly: data?.channelAssembly,
                }
            });
        }
    }

    const handleZoomIn = () => {
        setZoomInOut((prevZoom) => Math.min(prevZoom + 1, 25));
    };
    
    const handleZoomOut = () => {
        setZoomInOut((prevZoom) => Math.max(prevZoom - 1, 1));
    };

    const handleDragOvers = (event, date) => {
        handleDragOver(
            event, 
            date,
            draggedItem,
            setDraggableType,
            setPanelHoverDate,
            setPanelLinePosition,
            setPanelHoverTime,
            setHoveredId,
            zoomInOut,
            setLinePosition,
            setHoverTime,
        )
    }

    const handleAdsAndProgramDrop = (event, panelDate) => {
        handleDrop(
            event,
            panelDate,
            setHoveredId,
            setLinePosition,
            draggedItem,
            setPanelHoverTime,
            setPanelLinePosition,
            setPanelHoverDate,
            panelHoverTime,
            gridList,
            toast,
            setGridList,
            adValidate,
            hoverTime,
            newGridData,
            millisecondsToHuman,
            verifyMilliSeconds,
            setHoverTime,
            programValidate,
            locationState
        )
    }

    const handleDragOvers2 = (event, id) => {
        handleDragOver2(
            event, 
            id,
            draggedItem,
            setDraggableType,
            setHoveredId,
            zoomInOut,
            setLinePosition,
            setHoverTime,
        ) 
    }

    const programDelete = (event, uuid, panelDate) => {
        handleProgramDelete(
            event, 
            uuid,
            panelDate? panelDate : locationState?.state?.panelDate,
            gridList,
            setGridList,
            setShowPopup,
        )
    }

    const toGetAssetInfo = (sequenceId) => {
        const todayData = newGridData?.find(item => item.date === locationState?.state?.panelDate);
        getAssetInfo(
            sequenceId,
            todayData?.scheduleItems,
            setAssetInfo,
            setSeqId,
            "expandView"
        )
    }

    const handlecategoryTab = (tab) => {
        setCategoryTab(tab);
    };

    const selectedFillers = (id, adSqId, sequenceId) => {
        selectedFiller(
            id, 
            adSqId, 
            sequenceId, 
            locationState?.state?.panelDate,
            fillerList,
            gridList,
            setGridList,
            setAssetInfo,
        )
    }

    const updateAdsTime = (e, adSqId, sequenceId) => {
        setAdsTime(
            e, 
            adSqId, 
            sequenceId, 
            locationState?.state?.panelDate,
            gridList,
            setGridList,
            setAssetInfo,
            toast,
        )
    }

    const deleteAdEvent = (seqId, sequenceId) => {
        deleteEvent(
            seqId,
            sequenceId,
            locationState?.state?.panelDate,
            gridList,
            setGridList,
            setAssetInfo,
        )
    }

    const adAdsOnClick = (sequenceId) => {
        addAdsOnClick(
            sequenceId, 
            locationState?.state?.panelDate,
            locationState,
            adValidate,
            toast,
            gridList,
            setAssetInfo,
            setGridList,
            millisecondsToHuman,
        )
    }

    const updateSchedule = () => {
        updateLinearSchedule(
            setLoaderStatus,
            gridList,
            locationState,
            Schedule_update_weekly,
            toast,
            today,
            newGridData,
            fetchDataByDate
        );
    }

    const errorboxclose = () => {
        setErrorbox(false);
    }

    return (
        <>
            <div className={`content-body SchedulingDetail SchedulingLoop scheduling-loop-content-body ${appTheme}`}>
                <div className="dashboard-content flex schedule-loop-view">
                    <Left>
                        <SearchBar appTheme={appTheme} searchedText={searchedText} searchPrograms={searchPrograms} />
                        <ChannelListing programList={programList} promoList={promoList} fillerList={fillerList} locationState={locationState} channelDragStart={channelDragStart} handelProgramDoubleClick={handelProgramDoubleClick} draggedItem={draggedItem} />
                        <AdsButton locationState={locationState} draggedItem={draggedItem} channelDragStart={channelDragStart} />
                    </Left>
                    <Right customStyle={{ width: "100%", height: "100%" }}>
                        <div className="top-content d-flex align-items-start">
                            <DateNavigator locationState={locationState} prevWeekFunc={prevWeekFunc} startDate={startDate} endDate={endDate} nextWeekFunc={nextWeekFunc} today={today} viewType={"expandView"} />
                            <ButtonsToolBar trim_programs_space={trim_programs_space} locationState={locationState} loaderStatus={loaderStatus} updateSchedule={updateSchedule} undoGridList={undoGridList} redoGridList={redoGridList} canUndo={canUndo} canRedo={canRedo}/>
                        </div>
                        <div className="bottom-content row mt-2 px-2">
                            <MiddleContent>
                                <div className="middle-top mb-2">
                                    <ExpandScheduleHead gridList={gridList} locationState={locationState} backToLinear={backToLinear}/>
                                </div>
                                <div className="middle-up row">
                                    <ZoomControls handleZoomIn={handleZoomIn} handleZoomOut={handleZoomOut} />
                                    <ScheduleDetails appTheme={appTheme} totalDuration={totalDuration} totalVideoDuration={totalVideoDuration} totalAdDuration={totalAdDuration} totalPromosDuration={totalPromosDuration} />
                                    {/* <TableDetails appTheme={appTheme} item={item} millisecondsToHuman={millisecondsToHuman} /> */}
                                </div>
                                <div className="middle-down">
                                    <div className="content-wrapper" style={{ height: "475px" }}>    
                                        {
                                            (() => {
                                            const todayData = newGridData?.find(item => item?.date === locationState?.state?.panelDate);
                                            if (!todayData) return null;
                                            return (
                                                <TableBody expandViewHeight={"477px"} item={todayData} handleDragStart={handleDragStart} draggedItem={draggedItem} handleDragOvers={handleDragOvers} handleAdsAndProgramDrop={handleAdsAndProgramDrop}>
                                                    <TimeSlots timeSlots={timeSlotss} zoomInOut={zoomInOut} textColor={"#999999B8"} />
                                                    <div className="grid-list-container col-10 py-2 px-0" style={{ position: 'relative' }}>
                                                        {panelLinePosition !== null && panelHoverDate === todayData?.date && 
                                                        (draggableType === "programs" || draggableType === "draggable-list") && (
                                                            <PanelLine panelLinePosition={panelLinePosition} panelHoverTime={panelHoverTime} />
                                                        )}
                                                        {todayData?.length !== 0 ?
                                                            todayData?.scheduleItems?.map((data, index) => {
                                                                return (
                                                                    <DraggableItem handleDragOvers2={handleDragOvers2} data={data} calculateMinutes={calculateMinutes} millisecondsSinceMidnightUTC={millisecondsSinceMidnightUTC} zoomInOut={zoomInOut}>
                                                                        {linePosition !== null && hoveredId === data?.uuid && (draggableType === "fillers" || draggableType === "ads") && (
                                                                            <HoverLine linePosition={linePosition} hoverTime={hoverTime} />
                                                                        )}      
                                                                        <AdMarker data={data} calculateMinutes={calculateMinutes} zoomInOut={zoomInOut} viewType={"expandView"} />
                                                                        <DraggableEvent toGetAssetInfo={toGetAssetInfo} data={data} item={todayData} locationState={locationState} index={index} calculateMinutes={calculateMinutes} zoomInOut={zoomInOut} newGridData={newGridData} key={index} formatTime={formatTime} programDelete={programDelete} viewType={"expandView"} assetInfo={assetInfo} />
                                                                    </DraggableItem>  
                                                                )
                                                            })
                                                            :
                                                            <td colspan="5" class="text-center no-data">
                                                                No data has been scheduled.
                                                                {/* Nothing scheduled yet */}
                                                            </td>
                                                        }
                                                    </div>
                                                </TableBody>
                                            );
                                            })()  // <-- yeh () IIFE ko invoke karte hain
                                        }
                                    </div>
                                </div>
                            </MiddleContent>
                            <RightSideContent>
                                <AssetInfoCard assetInfo={assetInfo} millisecondsToHuman={millisecondsToHuman} appTheme={appTheme} categoryTab={categoryTab} viewType={"expandView"} formatTime={formatTime} />
                                <AdBreaksTable 
                                    appTheme={appTheme} 
                                    categoryTab={categoryTab} 
                                    handlecategoryTab={handlecategoryTab} 
                                    locationState={locationState} 
                                    assetInfo={assetInfo} 
                                    selectedFillers={selectedFillers} 
                                    fillerList={fillerList} 
                                    millisecondsToHuman={millisecondsToHuman} 
                                    updateAdsTime={updateAdsTime} 
                                    deleteAdEvent={deleteAdEvent} 
                                    deleteIcon={deleteIcon} 
                                    adAdsOnClick={adAdsOnClick} 
                                    viewType={"expandView"}
                                    promoList={promoList}
                                />
                                <NavigationButtons 
                                    appTheme={appTheme} 
                                    programDelete={programDelete} 
                                    assetInfo={assetInfo} 
                                    toGetAssetInfo={toGetAssetInfo} 
                                    gridList={gridList} 
                                    viewType={"expandView"}
                                    newGridData={newGridData}
                                    locationState={locationState}
                                />
                            </RightSideContent>
                        </div>
                    </Right>
                </div>
            </div>
            <ToastContainer />
            {
                loaderStatus &&
                <div className="loader-container">
                    <div className="loader"></div>
                    <p></p>
                </div>
            }
            { errorbox &&
                <ErrorPopup
                    btntext={"Yes"}
                    message={errorMessage}
                    closebox={() => errorboxclose()}
                    overrides={() => eventTrim()}
                />
            }
        </>
    )
}

export default LinearExpandView;